import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { planActions } from "variables/planActions";
import { postActionPlan } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    //height: 400,
    marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function AddActionPlanDialog(props) {
  const [name, setName] = useState("");
  const [priority, setPriority] = useState("");
  const [description, setDescription] = useState("");
  const [groups, setGroups] = useState([]);

  const [redirState, setRedirState] = useState(false);
  const [planActionId, setPlanActionId] = useState("");

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      name.length > 0 &&
      priority.length > 0 &&
      description.length > 0 &&
      groups.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, priority, description, groups]);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans/selectedplanaction/",
        state: { planActionId, planActionName: name },
      }}
    />
  );

  const handleSubmit = async (event) => {
    createPlanAction(event);
  };

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
  };

  let url = postActionPlan();
  const createPlanAction = async (event) => {
    console.log({
      groups,
      name,
      priority,
      description,
    });
    await axios
      .post(
        url,
        {
          general: {
            groups: [groups],
            name,
            status: "inprogress",
            lastupdate: moment().format("YYYY-MM-DD"),
            creationdate: moment().format("YYYY-MM-DD"),
            description,
            prevstartdate: "",
            prevenddate: "",
          },
          characteristics: {
            priority,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res.data.id);
        setPlanActionId(res.data.id);
        if (res.status == 200) {
          setNotification("success", "Plan d'action créé");
        } else setNotification("error", "Une erreur est survenue");
        //closeModal();
        //refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
    setRedirState(true);
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const priorityData = [
    { id: "1", name: "1" },
    { id: "2", name: "2" },
    { id: "3", name: "3" },
  ];

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div style={{ marginTop: "0.6rem" }}>
              <TextField
                required
                variant="outlined"
                id="nom-required"
                className={classes.textField}
                label={planActions.general.name}
                style={{ margin: 8, width: "62ch" }}
                defaultValue=""
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <FormControl
                required
                variant="outlined"
                className={classes.formControl}
              >
                <InputLabel id="priority-simple-select-outlined-label">
                  {planActions.characteristics.priority}
                </InputLabel>
                <Select
                  labelId="priority-simple-select-outlined-label"
                  id="priority-simple-select-outlined"
                  label="Priority"
                  value={priority}
                  className={classes.textField}
                  onChange={handlePriorityChange}
                >
                  {priorityData.map(({ id, name }) => (
                    <MenuItem key={id} value={id}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div style={{ marginTop: "0.6rem" }}>
                <TextField
                  required
                  variant="outlined"
                  id="nom-required"
                  className={classes.textField}
                  label={planActions.general.description}
                  style={{ margin: 8, width: "62ch" }}
                  defaultValue=""
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                  multiline
                  rowsMax={4}
                />
              </div>
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Créer
            </Button>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  multiSelect={false}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
      </form>
      {redirecting}
    </>
  );
}

export default AddActionPlanDialog;
